import React, { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../Sidebar';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { Loader } from '../../shared/atoms/loader';
import styles from './AppLayout.module.scss';

const AppLayout: React.FC = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <div className={styles.layout}>
      <Sidebar expanded={sidebarExpanded} onToggle={() => setSidebarExpanded((prev) => !prev)} />
      <Header sidebarExpanded={sidebarExpanded} />
      <main className={`${styles.content} ${sidebarExpanded ? '' : styles.contentCollapsed}`}>
        <Suspense fallback={<Loader fullPage size="lg" />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer sidebarExpanded={sidebarExpanded} />
    </div>
  );
};

export default AppLayout;
